import React from "react";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import TablePagination from "@material-ui/core/TablePagination";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link, Link as RouterLink } from "react-router-dom";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {
  Delete,
  Edit,
} from "@material-ui/icons";
import { IconButton, makeStyles } from "@material-ui/core";
import { toast } from "react-toastify";
import { useRowSelect, useTable } from "react-table";

// import MovieTable from "../MovieTable";
import { modal, CustomCheckbox } from "../../../../util";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import TablePaginationActions from "@material-ui/core/TablePagination/TablePaginationActions";
import { DatePicker } from "@material-ui/pickers";
import InputAdornment
  from "@material-ui/core/InputAdornment";
import ClearIcon from "@material-ui/icons/Clear";

const StatusFilter = styled.ul`
  list-style: none;
  display: inline-flex;
  padding: 0;
  li {
    button {
      border: 0px;
      background: transparent;
      color: #306f9d;
      font-size: 13px;
      line-height: 15px;
      padding: 0 10px;
      cursor: pointer;
      &.active {
        font-weight: bold;
        color: #333333;
      }
    }
    &:not(:last-of-type) {
      button {
        border-right: 1px solid black;
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  iconBtn: {
    color: "#CCCCCC",
    margin: 5,
  },
  status: {
    textTransform: "lowercase",
    "&:first-letter": {
      textTransform: "uppercase",
    },
  },
}));

// function TablePaginationActions(props) {
//   const classes = useStyles();
//   const theme = useTheme();
//   const { count, page, rowsPerPage, onChangePage } = props;

//   const handleBackButtonClick = (event) => {
//     onChangePage(event, page - 1);
//   };

//   const handleNextButtonClick = (event) => {
//     onChangePage(event, page + 1);
//   };

//   return (
//     <div className={classes.root}>
//       <PaginationIconButton
//         onClick={handleBackButtonClick}
//         disabled={page === 0}
//         aria-label="previous page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowRight />
//         ) : (
//           <KeyboardArrowLeft />
//         )}
//       </PaginationIconButton>
//       <PaginationIconButton
//         onClick={handleNextButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="next page"
//         className="right"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowLeft />
//         ) : (
//           <KeyboardArrowRight />
//         )}
//       </PaginationIconButton>
//     </div>
//   );
// }

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return <CustomCheckbox type="checkbox" ref={resolvedRef} {...rest} />;
  }
);

function ImportButton(props) {
  const { disabled, onChangeHandler } = props;
  const ref = React.useRef();

  const reset = () => {
    console.log("here");
    ref.current.value = "";
  };

  return (
    <label htmlFor="import-data">
      <input
        id="import-data"
        type="file"
        hidden
        onChange={(event) => {
          onChangeHandler(event, reset);
        }}
        ref={ref}
      />
      <Button
        variant="contained"
        component="span"
        color="primary"
        disabled={disabled}
      >
        Import from .csv
      </Button>
    </label>
  );
}

function ImportImageButton(props) {
  const { disabled, onChangeHandler } = props;
  const ref = React.useRef();

  const reset = () => {
    console.log("here");
    ref.current.value = "";
  };

  return (
    <label htmlFor="import-image-data">
      <input
        id="import-image-data"
        type="file"
        hidden
        onChange={(event) => {
          onChangeHandler(event, reset);
        }}
        ref={ref}
        accept=".zip"
      />
      <Button
        variant="contained"
        component="span"
        color="primary"
        disabled={disabled}
      >
        Import images
      </Button>
    </label>
  );
}

export default function MovieListingPage({ disabled, ...props }) {
  const { match } = props;
  const classes = useStyles();
  const { setLoading } = useLoading();
  const [type, setType] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [actionType, setActionType] = React.useState("");
  const [selectedDate, handleDateChange] = React.useState(null);
  const [queryDate, setQueryDate] = React.useState(null);
  const [keyword, setKeyword] = React.useState("");
  const [queryString, setQueryString] = React.useState("");

  // for pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalElements, setTotalElements] = React.useState(0);
  const [dataSizes] = React.useState({
    all: 0,
    published: 0,
    draft: 0,
  });

  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref) => <Link ref={ref} {...linkProps} />),
    []
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "Title",
        accessor: "title",
        Cell: ({ row, cell }) => {
          return (
            <Link
              to={`/cinefan/movies/edit/${row.original.id}`}
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
            >
              {row.original.title}
            </Link>
          );
        },
      },
      // {
      //   Header: "Programme",
      //   accessor: "programme",
      // },
      // {
      //   Header: "Ordering",
      //   accessor: "order",
      // },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Last Updated",
        accessor: "updateDate",
      },
    ],
    []
  );

  const { getTableProps, headerGroups, rows, prepareRow, selectedFlatRows } =
    useTable(
      {
        columns,
        data,
      },
      useRowSelect,
      (hooks) => {
        hooks.visibleColumns.push((columns) => [
          // Let's make a column for selection
          {
            id: "selection",
            // The header can use the table's getToggleAllRowsSelectedProps method
            // to render a checkbox
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <div>
                <IndeterminateCheckbox
                  {...{ ...getToggleAllRowsSelectedProps(), disabled }}
                />
              </div>
            ),
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) => (
              <div>
                <IndeterminateCheckbox
                  {...{ ...row.getToggleRowSelectedProps(), disabled }}
                />
              </div>
            ),
          },
          ...columns,
          {
            id: "action",
            // The header can use the table's getToggleAllRowsSelectedProps method
            // to render a checkbox
            Header: () => <div>Action</div>,
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) => (
              <div>
                <IconButton
                  className={classes.iconBtn}
                  size="small"
                  component={CustomLink}
                  to={`/cinefan/movies/edit/${row.original.id}`}
                >
                  <Edit fontSize="small" />
                </IconButton>
                {disabled || (
                  <IconButton
                    className={classes.iconBtn}
                    size="small"
                    // component={CustomLink}
                    onClick={() => {
                      deleteMovie(row.original.id);
                    }}
                  >
                    <Delete fontSize="inherit" />
                  </IconButton>
                )}
              </div>
            ),
          },
        ]);
      }
    );

  const getMovies = React.useCallback(async () => {
    let dateValue = null;
    if (rowsPerPage > 0) {
      setLoading(true);

      if (queryDate) {
        const date = new Date(queryDate);
        let month = date.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        dateValue = date.getFullYear() + "-" + month + "-01";
      }

      let pageNum = page;
      try {
        const result = await apiHelper.cinefan.getMovies(
          "en",
          pageNum,
          (page + 1) * rowsPerPage,
          rowsPerPage,
          type,
          queryString,
          dateValue
        );
        setData(result.data.content.filter((x) => x));
        setTotalElements(result.data.totalElements);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  }, [page, rowsPerPage, type, queryString, setLoading, queryDate]);

  const getAllMovie = React.useCallback(async () => {
    let dateValue = null;
    setLoading(true);
    try {
      if (queryDate) {
        const date = new Date(queryDate);
        let month = date.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        dateValue = date.getFullYear() + "-" + month + "-01";
      }
      const result = await apiHelper.cinefan.getAllMovies(
        "en",
        type,
        queryString,
        dateValue
      );
      setData(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [type, queryString, setLoading, queryDate]);

  const filterHandler = (targetType) => () => {
    setType(targetType);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const triggerSearch = React.useCallback(() => {
    setQueryString(keyword);
  }, [keyword]);

  const handleChangeRowsPerPage = (event) => {
    if (event.target.value > 0) {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    } else {
      getAllMovie();
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    }
  };

  const handleSelectChange = (e) => {
    setActionType(e.target.value);
  };

  const handleBulkAction = React.useCallback(async () => {
    const ids = selectedFlatRows.map((o) => o.original.id);
    if (ids.length > 0) {
      const decision = await modal.fire({
        title: `${actionType} Movie`,
        text: `Are you sure to ${actionType.toLowerCase()} ${ids.length} movie(s)?`,
        showCancelButton: true,
        confirmButtonText: actionType,
      });
      if (decision.isConfirmed) {
        switch (actionType) {
          case "Delete":
            try {
                const promises = ids.map((id) =>
                  apiHelper.cinefan.deleteMovie(id)
                );
                const results = await Promise.all(promises);
                console.log(results);
                toast.dark(`${ids.length} movie(s) deleted.`);
                getMovies();
              } catch (err) {
                console.log(err);
              }
            break;
          case "Publish":
              try {
                const result = await apiHelper.cinefan.bulkPublishMovies(ids);
                if (result.data.code === 0) {
                  getMovies();
                  console.log(result);
                  toast.dark(`${ids.length} movie(s) published.`)
                }
              } catch (err) {
                console.log(err);
              }
            break;
          default:
            break;
        }
      }
    }
  }, [selectedFlatRows, actionType]);

  const deleteMovie = async (id) => {
    const decision = await modal.fire({
      title: "Delete Movie",
      text: "Are you sure to delete this movie?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.cinefan.deleteMovie(id);
        toast.dark("Deleted movie.");
        getMovies();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleFileUpload = async (event, reset) => {
    event.preventDefault();
    const fd = new FormData();
    fd.append("file", event.target.files[0]);
    try {
      const result = await apiHelper.cinefan.importMovie(fd);
      if (0 === result?.data?.code) {
        toast.dark("Successfully imported.");
        getMovies();
      }
    } catch (err) {
      console.log(err);
    } finally {
      reset();
    }
  };

  const handleImageUpload = async (event, reset) => {
    event.preventDefault();
    const fd = new FormData();
    fd.append("file", event.target.files[0]);
    try {
      const result = await apiHelper.cinefan.importMovieImage(fd);
      if (0 === result?.data?.code) {
        toast.dark("Images successfully imported.");
        getMovies();
      }
    } catch (err) {
      console.log(err);
    } finally {
      reset();
    }
  };

  React.useEffect(() => {
    getMovies();
  }, [getMovies]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Movies
      </Typography>
      <StatusFilter>
        <li>
          <button
            className={type === null ? "active" : ""}
            type="button"
            onClick={filterHandler(null)}
          >
            <Typography variant="p">
              All <span>({dataSizes.all})</span>
            </Typography>
          </button>
        </li>
        <li>
          <button
            className={type === "PUBLISHED" ? "active" : ""}
            type="button"
            onClick={filterHandler("PUBLISHED")}
          >
            <Typography variant="p">
              Published <span>({dataSizes.published})</span>
            </Typography>
          </button>
        </li>
        <li>
          <button
            className={type === "DRAFT" ? "active" : ""}
            type="button"
            onClick={filterHandler("DRAFT")}
          >
            <Typography variant="p">
              Draft <span>({dataSizes.draft})</span>
            </Typography>
          </button>
        </li>
      </StatusFilter>
      <Grid container justify="space-between">
        <Grid container item xs={6} md={6}>
          <Grid container item xs={6}>
            <Grid item xs>
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">
                  Bulk Actions
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={actionType}
                  onChange={handleSelectChange}
                  label="Bulk Actions"
                  disabled={disabled}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"Delete"}>Delete</MenuItem>
                  <MenuItem value={"Publish"}>Publish</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                onClick={handleBulkAction}
                variant="outlined"
                color="primary"
                disabled={disabled}
              >
                Apply
              </Button>
            </Grid>
          </Grid>
          <Grid container item xs={6}>
            <Grid item>
              <DatePicker
                fullWidth
                variant="inline"
                inputVariant="outlined"
                openTo="year"
                margin="dense"
                views={["year", "month"]}
                label="Year and Month"
                value={selectedDate}
                onChange={handleDateChange}
                InputProps={{
                  endAdornment: (
                      <InputAdornment
                          style={selectedDate || {display: "none"}}
                          position="end"
                      >
                        <ClearIcon
                            style={{cursor: "pointer"}}
                            fontSize="small"
                            onClick={(event) => {
                              handleDateChange(null);
                              setQueryDate(null);
                              event.preventDefault();
                              event.stopPropagation();
                              return false;
                            }}
                        />
                      </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item>
              <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setQueryDate(selectedDate);
                  }}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} md={6}>
          <Box
              width="100%"
            component="span"
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box display="flex">
              <ImportImageButton
                onChangeHandler={handleImageUpload}
                disabled={disabled}
              />
            </Box>
            <Box display="flex">
              <ImportButton
                onChangeHandler={handleFileUpload}
                disabled={disabled}
              />
            </Box>
            <Box display="flex">
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to={`${match.url}/edit/new`}
                disabled={disabled}
              >
                Add New Movie
              </Button>
            </Box>
            <Box display="flex">
              <TextField
                id="outlined-error"
                label="Search Movie"
                variant="outlined"
                margin="dense"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
            </Box>
            <Box display="flex">
              <Button
                variant="outlined"
                color="primary"
                type="button"
                onClick={triggerSearch}
              >
                Search
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* <MovieTable
        data={rows}
        passTableRows={setTableRows}
        deleteMovie={deleteMovie}
      /> */}
      <Paper>
        <Table aria-label="simple table" component="ul" {...getTableProps()}>
          <TableHead component="div">
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell
                    {...column.getHeaderProps()}
                    style={{ paddingTop: 6, paddingBottom: 6 }}
                  >
                    {column.render("Header")}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <TableRow {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <TableCell
                        {...cell.getCellProps()}
                        style={{
                          paddingTop: 6,
                          paddingBottom: 6,
                          color:
                            cell.column.id === "updateDate"
                              ? "#333333"
                              : "#306F9D",
                        }}
                        className={
                          cell.column.id === "status" && classes.status
                        }
                      >
                        {cell.render("Cell")}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>

      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
        colSpan={7}
        count={totalElements}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
          style: {
            background: "white",
            border: "1px solid #CCCCCC",
            borderRadius: "4px",
          },
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
        labelRowsPerPage="Show rows"
      />
    </Box>
  );
}
